import { render, staticRenderFns } from "./BaseInfoForm.vue?vue&type=template&id=42d5a202&scoped=true"
import script from "./BaseInfoForm.vue?vue&type=script&lang=js"
export * from "./BaseInfoForm.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoForm.vue?vue&type=style&index=0&id=42d5a202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d5a202",
  null
  
)

export default component.exports